var App = App || {};

App.BlockFaqs = (function ($) {
    'use strict';

    function init() {
        Full();
        List();
    }

    function Full() {

        const block = $(".block-faqs-full").first();
        const keys = ["Group", "Category", "SearchTerm"];

        if (block.length === 1) {
            keys.every(key => {
                if (App.Base.GetUrlParameter(key) !== "") {
                    $('html, body').animate({
                        scrollTop: block.offset().top
                    }, 300);
                    return false;
                }
                else {
                    return true;
                }
            });
        }
    }

    function List() {

        const block = $(".block-faqs-list");

        block.each(function () {

            const button = $(this).find(".block-faqs-list-ctas button");

            button.on("click", function () {

                const target = $("#" + $(this).attr("aria-controls"));

                if ($(this).attr("aria-expanded") == "false") {
                    target.slideDown(300);
                    $(this).attr("aria-expanded", "true");
                }
                else {
                    target.slideUp(300);
                    $(this).attr("aria-expanded", "false");
                }
            });
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.BlockFaqs.init();
});